<template>
  <el-dialog
    title="Pay UNIT"
    :visible.sync="isOpen"
    width="7.2rem"
    append-to-body
    :close-on-click-modal="false"
    destroy-on-close
  >
    <div class="warn-text"><i class="el-icon-warning"/>You should pay at least 1 UNIT to propose successfully</div>
    <div class="detail-item spaceLeft">
      <span class="detail-item-label">UNIT :</span>
      <div class="balance-box">
        <el-input v-model="inputVal" type='number'
          ><template slot="append"
            ><span class="unit"
              >Balance : <big-number :number="balance"/></span></template
        ></el-input>
      </div>
      <div class="text-1">
        Your UNIT payment will be counted in your vote directly.
      </div>
    </div>

    <div class="text-2">
      Proposals may pass when they receive more than
      <span style="font-size:0.28rem;color:#1F1F1F;"><big-number :number="threshold"/></span>
      UNITs of votes.
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">Cancel</el-button>
      <loading-btn
        class="common-btn-blue-sm"
        label="Submit"
        @clickHandle="save"
      />
    </span>
  </el-dialog>
</template>

<script>
import { createProposal } from "@/api/dao.js"
import { toBigNum, toBigItem } from "@/utils/bigNumberTran.js";
export default {
  data() {
    return {
      loading: false,
      isOpen: false,
      inputVal: undefined,
      balance: 0,
      pageData:{},
      toObj2:{},
      threshold:0
    };
  },
  components: {  },
  methods: {
    open( data ) {
      this.pageData = data.pageData;
      this.toObj2 = data.toObj2;
      this.fromObj = data.fromObj;
      this.init();
      this.getBalance();
      this.getThreshold();
      this.isOpen = true;
      this.inputVal = undefined;
    },
    close() {
      this.inputVal = undefined;
      this.isOpen = false;
    },
    init() {
      this.contractDao = this.$store.getters.contractMap["contractDao"].contract;
      this.contractDaoAdd = this.$store.getters.contractMap["contractDao"].address;
      console.log(this.contractDao)
    },
    async getBalance() {
      try {
        this.balance = await web3.eth.getBalance(
          this.$store.getters.metaMaskObj.account
        );
      } catch (e) {
        console.log("getBalance--", e);
      }
    },
    async getThreshold() {
      try {
        this.threshold = await web3.eth.getBlockNumber()
        .then(result => {
            console.dir(result);
            /* 查询当前区块所需票数 */
          return this.contractDao.methods.quorum(result).call({from: this.$store.getters.metaMaskObj.account})

        });
        console.log(this.threshold)
      } catch (e) {
        console.log(e);
      }
    },
    save(btn){
      this.btn = btn;
      if (this.inputVal < 1){
        this.$message.warning("You should pay at least 1 UNIT to propose successfully");
        this.btn && this.btn.closeLoad();
        return;
      }
      if (toBigItem(this.inputVal).comparedTo(this.balance) > 0){
        this.$message.warning("Insufficient UNIT balance");
        this.btn && this.btn.closeLoad();
        return;
      }
      createProposal(this.pageData).then(res => {
        this.saveType();
      }).catch(e => {
        console.log(e);
        this.btn && this.btn.closeLoad();
      })
    },
    saveType() {
      console.log(this.pageData.title)
      const tx_builder = this.contractDao.methods["propose"]([],[],this.pageData.title);
      const encoded_tx = tx_builder.encodeABI();

      web3.eth
        .sendTransaction({
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: this.contractDaoAdd,
          value: toBigNum(this.inputVal),
          data: encoded_tx
        })
        .then(res => {
          this.btn && this.btn.closeLoad();
          this.$message.success("Proposed successfully!");
          this.$emit("success");
          this.close();
        })
        .catch(error => {
          if(error.code === 4001){
            this.$message.error("You have rejected this transaction");
          }else{
            this.$message.error("operation failed");
          }
          console.log(error);
          this.btn && this.btn.closeLoad();
        });
    }
  },
  created() {}
};
</script>
<style scoped lang="scss">
/deep/ .el-dialog__header {
  font-weight: bold;
}
.balance-box {
  position: relative;
  flex: 1 0 0;
  /deep/ .el-input__inner {
    height: 0.48rem;
    background: #f7f8fa;
    border-color: #f7f8fa;
    color: #929DAD;
  }
  /deep/ .el-input-group__append {
    background: #f7f8fa;
    border-color: #f7f8fa;
    font-size: 0.18rem;
    color: #929DAD;
  }
}
.detail-item {
  margin-bottom: 0.35rem;
}
.warn-text{
  font-size: 0.24rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: #1F1F1F;
  margin-bottom:0.4rem;
  white-space: nowrap;
  i{
    color:#FAAD14;
    margin-right: 0.12rem;
  }
}
.text-1{
  font-size: 0.2rem;
  font-weight: 400;
  color: #AAAAAA;
  margin:0.16rem 0 0 0.56rem;
}
.text-2{
  font-size: 0.2rem;
  font-weight: 400;
  color: #6B6B6B;
  margin-left:0.24rem;
  margin-top:0.16rem;
}
</style>
